import { Link } from 'react-router-dom';
import { featuredVideos } from '@/mocks/home';

export default function FeaturedVideos() {
  return (
    <section className="w-full bg-background-100 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            精选推荐
          </h2>
          <Link
            to="/category/dianying"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            更多推荐
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredVideos.map((video) => (
            <Link
              key={video.slug}
              to={`/article/${video.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all hover:-translate-y-1"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={video.image}
                  alt={video.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-background-950/70 text-background-50">
                    {video.duration}
                  </span>
                </div>
                <div className="absolute top-2 right-2 flex items-center gap-1 px-2 py-0.5 rounded-md bg-background-950/70 text-background-50 text-xs">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                  </div>
                  {video.rating}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 line-clamp-1">
                  {video.title}
                </h3>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{video.category}</span>
                  <span className="text-xs text-foreground-400">{video.updateTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}